@if (modalSvc.displayToast()) {
  <div @slideInOut
    class="ibe-toast-box py-3 position-fixed d-flex align-items-center justify-content-between {{ modalSvc?.toastInfo().type }}"
    [ngClass]="{
      'rtl text-end pe-4 ps-3': storeSvc.RTL_Flag(),
      'pe-3 ps-4': !storeSvc.RTL_Flag(),
    }"
  >
    <div>
      @if (modalSvc?.toastInfo().title?.length) {
        <h3 class="ibe-toast-title m-0 pb-2" [innerHTML]="modalSvc?.toastInfo().title"></h3>
      }

      @if (modalSvc?.toastInfo().desc?.length) {
        <span class="ibe-toast-desc d-block"
          [class.ps-1]="storeSvc.RTL_Flag()"
          [class.pe-1]="!storeSvc.RTL_Flag()"
          [innerHTML]="modalSvc?.toastInfo().desc"
        ></span>
      }
    </div>
    <app-button variant="close" label="Close Button" (onClickEvent)="modalSvc.handleToastClose()" />
  </div>
}
